<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import router from "../../router";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

export default {
  name: "Employees",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      currentSorting: "",
      role: {
        name: "",
        pos: false,
        back_office: false,
        apply_discount_restricted: false,
        view_all_receiptis: false,
        manage_open_tickets: false,
        saved_open_tickets: false,
        shift_report: false,
        change_tax: false,
        purchase_returns: false,
        open_cash_drawer: false,
        edit_items: false,
        change_setting: false,
        access_livechat: false,
        menu_reports: false,
        menu_employees: false,
        menu_customers: false,
        edit_profile: false,
        menu_items: false,
        manage_billing: false,
        set_payment_type: false,
        set_taxes: false,
        manage_pos: false,
        kitchen_printer: false,
        dining_option: false,
        support: false
      },
      filterObj: {
        sort_by: "",
        order_by: "ASC"
      }
    };
  },

  mixins: [accessible],

  methods: {
    getList(page) {
      this.list = [];

      this.$api
        .getAPI({
          _action: "/role/all-list"
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_roles_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    details(id) {
      this.role = {};
      this.$api
        .getAPI({
          _action: "/role/detail/" + id
        })
        .then(res => {
          this.role = res;
        });
    },

    setObj(id, name) {
      this.role.id = id;
      this.$refs.deleteRoleAlert.message = this.$lang.messages.are_you_sure_you_want_to_delete_the_role;
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },

    save() {
      this.$api
        .postAPI({
          _action: "/role/",
          _body: this.role,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
          this.getList(1);
        })
        .catch(e => {
          console.log(e.message);
        });
    },

    gotoAccessRightEdit(id) {
      router.push("/edit-access-rights/" + id);
    },

    deleteRole(e) {
      if (this.role.id) {
        this.$api
          .deleteAPI({
            _action: "/role/delete/" + this.role.id
          })
          .then(res => {
            this.$refs.deleteRoleAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.role.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteRoleAlert.close();
          });
      }
    },

    clearAddModal() {
      this.role.name = "";
      this.$validator.reset();
      this.errors.clear();
    }
  },
  mounted() {
    this.getList(1);

    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.currentUser = payload
    });
  }
};
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-right">
              <button
                @click="checkPendingAccountStatus($event, 'add-access-rights')"
                class="btn btn-primary px-4"
              >+ {{$lang.messages.add_role}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col" width="35"></th>
                      <th scope="col">{{$lang.messages.role}}</th>
                      <th scope="col">{{$lang.messages.access}}</th>
                      <th scope="col">{{$lang.messages.employees}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="clickable-row" v-for="(role,i) in list" :key="role.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td class="pr-0">
                        <img src="/images/team-group.png" width="39" />
                      </td>
                      <td class="align-middle">{{role.name}}</td>
                      <td class="align-middle" v-if="!role.pos && !role.back_office">-</td>
                      <td
                        class="align-middle"
                        v-else-if="role.pos && role.back_office"
                      >{{$lang.messages.back_office_and_pos}}</td>
                      <td
                        class="align-middle"
                        v-else-if="role.pos || !role.back_office"
                      >{{$lang.messages.pos}}</td>
                      <td
                        class="align-middle"
                        v-else-if="!role.pos || role.back_office"
                      >{{$lang.messages.back_office}}</td>
                      <td class="align-middle">{{role.employees}}</td>
                      <td class="text-center text-nowrap">
                        <a
                          href="javascript:void(0)"
                          @click="gotoAccessRightEdit(role.id)"
                          class="text-primary mr-2 font-18">
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        <a
                          href="javascript:void(0)"
                          @click="setObj(role.id, role.name)"
                          class="text-primary mr-2 font-18"
                          data-toggle="modal"
                          v-if="!role.is_checked"
                          data-target="#delete-role-modal">
                          <i class="far fa-trash-alt font-20 text-danger"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Alert
      @rightButtonEvent="deleteRole($event)"
      v-bind:title="$lang.messages.delete_role"
      ref="deleteRoleAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-role-modal"
    />
  </div>
</template>
